module.exports = __webpack_public_path__ + "img/symbol_12.3f50e14d.png";